import { Copyable } from '@components'

import { Flex, Spacing, Text } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { Contact } from '@features/contacts/types/contact'

import { getRegistrationNumberLabel } from '../../utils/getRegistrationNumberLabel'

interface ClientInformationPrimaryFieldsProps {
  contact: Contact
  postalAddress: string | null
  deliveryAddress: string | null
}

export const ClientInformationPrimaryFields = ({
  contact,
  postalAddress,
  deliveryAddress,
}: ClientInformationPrimaryFieldsProps) => {
  const { t } = useTranslation()

  return (
    <Flex flexDirection="column" alignItems="flex-start" gap={Spacing.S12}>
      {contact.registrationNo && (
        <>
          <Text weight="bold">{getRegistrationNumberLabel(contact.countryId, t)}</Text>
          <Copyable valueToCopy={contact.registrationNo}>{contact.registrationNo}</Copyable>
        </>
      )}

      {postalAddress && (
        <>
          <Text weight="bold">{t('contact.detail.postal_address')}</Text>
          <Copyable valueToCopy={postalAddress}>{postalAddress}</Copyable>
        </>
      )}

      {deliveryAddress && (
        <>
          <Text weight="bold">{t('contact.detail.delivery_address')}</Text>
          <Copyable valueToCopy={deliveryAddress}>{deliveryAddress}</Copyable>
        </>
      )}

      {contact.phone && (
        <>
          <Text weight="bold">{t('contact.detail.phone')}</Text>
          <Copyable valueToCopy={contact.phone}>{contact.phone}</Copyable>
        </>
      )}
    </Flex>
  )
}
